import React from "react";
import MultiComboboxSetter from "../Combobox/MultiComboboxSetter";
import { ComboboxOption } from "../Combobox/Combobox";
import { Button, Colors, Display, Sizes } from "../Button/Button";
import { ButtonGroup } from "../Button/ButtonGroup";
import { DropdownProps } from "semantic-ui-react";
import ButtonAsyncState from "../Button/ButtonAsyncState";
import { getBusinessPaymentMethod } from "Hooks/Api/apiStripe";

type Props = {
	businessEntityIds: string[],
	setBusinessEntityIds: (ids: string[]) => void,
	availableBusinessEntities: ComboboxOption<string>[],
	onCancel?: () => void;
	afterSelection?: () => Promise<void>;
}

export const BusinessEntitySelection: React.FunctionComponent<Props> = ({
	businessEntityIds,
	setBusinessEntityIds,
	availableBusinessEntities,
	afterSelection,
	onCancel,
}) => {
	const [dynamicOptions, setDynamicOptions] = React.useState<ComboboxOption<string>[]>(availableBusinessEntities);
	const [businessEntityToBeOverwrittenWarning, setBusinessEntityToBeOverwrittenWarning] = React.useState<string[]>([]);

	const handleAfterSet = (y: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
		const value = data.value as string[];
		if (
			value.includes("all") || 
			businessEntityIds.length === availableBusinessEntities.filter(x => x.value !== "all").length
		) {
			setDynamicOptions(availableBusinessEntities.filter(x => x.value !== "all"));
			setBusinessEntityIds(
				availableBusinessEntities
					.filter(x => x.value !== "all")
					.map(x => x.value as string)
			);
		} else {
			setBusinessEntityIds(value);
			setDynamicOptions(availableBusinessEntities);
		}

		value.forEach(async id => {
			const response = await getBusinessPaymentMethod(id);
			
			if (response.status === 200 && !!response.data?.id) {
				const name = availableBusinessEntities.find(x => x.value === id)?.display?.toString();
				if (!!name) {
					setBusinessEntityToBeOverwrittenWarning([...businessEntityToBeOverwrittenWarning, name]);
				}
			}
		});
	}

	return (
		<div className="business-entity-selection">
			<h4>Select Business Entities</h4>
			<MultiComboboxSetter
				label=""
				value={businessEntityIds}
				getOptionValue={v => v}
				setValue={v => setBusinessEntityIds(v)}
				options={dynamicOptions}
				onAfterSet={handleAfterSet}
				searchable
				labelVisible={false}
			/>

			{businessEntityToBeOverwrittenWarning.length > 0 && (
				<div className="alert alert__warning">
					<p>The following business entities will have their existing payment details overwritten:</p>
					<p>
						<ul>
							{businessEntityToBeOverwrittenWarning.map(x => (
								<li>{x}</li>
							))}
						</ul>
					</p>
				</div>
			)}
			{(onCancel || afterSelection) && (
				<ButtonGroup className="modal__actions">
					<Button key="cancel" onClick={onCancel} display={Display.Outline}>Cancel</Button>
					{afterSelection && (
						<ButtonAsyncState
							onPress={afterSelection}
							display={Display.Solid}
							sizes={Sizes.Medium}
							colors={Colors.Primary}
							readonly={businessEntityIds.length <= 0}
							waitingText="Processing..."
						>
							Continue
						</ButtonAsyncState>
					)}
				</ButtonGroup>
			)}
		</div>
	)
}